<template lang="html">
  <div class="component-wrapper">
    <v-container>
      <v-card>
        <v-layout justify-center>
        <v-slide-group
          v-model="tab"
          mandatory
        >
        <v-slide-item v-slot:default="{ active, toggle }">
          <v-col>
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Vizsga adatai</span>
            <v-icon></v-icon>
          </v-btn>
          </v-col>
        </v-slide-item>
        <v-slide-item v-slot:default="{ active, toggle }" v-if="exam_gui_id !== 'Új vizsga'">
          <v-col>
          <v-btn
            text
            :input-value="active"
            active-class="orange--text"
            @click="toggle"
          >
            <span>Vizsgázók</span>
            <v-icon>account_circle</v-icon>
          </v-btn>
          </v-col>
        </v-slide-item>
        </v-slide-group>
        </v-layout>
            <div v-show="tab == 0" name="vizsgajelento_data">
              <br>
              <v-container>
                <v-form
                  ref="exam_form"
                  v-model="valid"
                >
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="exam_gui_id" label="Azonosító" outlined disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                    :rules="[rules.required]"
                    v-model="school_select"
                    :items="driving_schools"
                    item-text="driving_school_name"
                    item-value="driving_school_id"
                    return-object
                    label="Iskola választása"
                    :disabled="exam_id != null"
                    outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu ref="exd_menu" v-model="exam_date_menu" :close-on-content-click="false" :return-value.sync="exam_date" transition="scale-transition" offset-y  min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field @submit.prevent="checkLogin" v-model="exam_date" label="Dátum" append-icon="event" readonly v-on="on" outlined>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="exam_date" no-title scrollable first-day-of-week=1>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="exam_date_menu = false">Mégsem</v-btn>
                        <v-btn text color="primary" @click="$refs.exd_menu.save(exam_date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-menu ref="ext_menu" v-model="exam_time_menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="exam_time" transition="scale-transition" offset-y  max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="exam_time" label="Időpont" append-icon="access_time" readonly v-on="on" outlined></v-text-field>
                      </template>
                      <v-time-picker format="24hr" v-if="exam_time_menu" v-model="exam_time" >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="exam_time_menu = false">Mégsem</v-btn>
                        <v-btn text color="primary" @click="$refs.ext_menu.save(exam_time)">OK</v-btn>
                      </v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="selected_exam_type"
                      :items="exam_types"
                      item-value="code"
                      label="Vizsga típusa"
                      outlined
                      return-object
                      :rules="[rules.required]"
                      >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="selected_megyekir"
                      :items="exam_megyekir"
                      item-text="[KirendeltsegNev]"
                      item-value="[MegyeKir]"
                      label="Kirendeltség"
                      outlined
                      :disabled="!selected_exam_type || vizsgaform_loader"
                      :loading="vizsgaform_loader"
                      :rules="[rules.required]"
                      >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="selected_vizsgahely"
                      :items="exam_vizsgahely"
                      item-text="[Nev]"
                      item-value="[VizsgaHelyszinKod]"
                      label="Vizsgahelyszín"
                      outlined
                      return-object
                      :disabled="!selected_megyekir || vizsgaform_loader"
                      :loading="vizsgaform_loader"
                      :rules="[rules.required]"
                      >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="selected_vizsgatipus"
                      :items="exam_vizsgatipus"
                      item-text="desc"
                      item-value="code"
                      label="Vizsga fajtája"
                      outlined
                      :disabled="!selected_vizsgahely || vizsgaform_loader"
                      :loading="vizsgaform_loader"
                      :rules="[rules.required]"
                      >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="selected_payment_type"
                      :items="payment_type"
                      label="Befizetés típusa"
                      outlined
                      :rules="[rules.required]"
                      >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="place_limit"
                      label="Max létszám"
                      type="number"
                      max="30"
                      min="0"
                      outlined
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" md="4">
                  <v-switch v-model="last_exam" label="Utolsó vizsga"></v-switch>
                  </v-col>
                  <v-col cols="6" md="4">
                  <v-switch v-model="is_published" label="Meghirdetve"></v-switch>
                  </v-col>
                  <v-col cols="6" md="4">
                  <v-switch v-model="is_preregistrabled" label="Előregisztrálható"></v-switch>
                  </v-col>
                </v-row>
                <v-row>

                  <v-col cols="6" md="3">
                    <v-btn v-if="exam_gui_id == 'Új vizsga'" :disabled="!valid || preloader" rounded color="primary" @click="SaveExam">
                      Mentés
                      <v-icon right dark>send</v-icon>
                    </v-btn>
                    <v-btn @click="updateexam_dialog = true" v-if="exam_id" :disabled="preloader || !valid" rounded color="primary">
                      Módosít
                      <v-icon right dark>send</v-icon>
                    </v-btn>
                  </v-col>

                    <v-dialog v-model="updateexam_dialog" persistent max-width="330">
                      <v-card>
                        <v-card-text>
                          <p class="pt-4"><b>Biztosan módosítani szeretné a vizsgát?</b></p>
                          <p v-if="status == 'Finalized'" class="red--text"><b>A vizsga már fel lett töltve az NKH rendszerébe!</b> (A módosítás nem kerül feltöltésre, kizárólag a Diák Nyilvántartóban módosulnak az adatok!)</p>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn :disabled="!updateexam_dialog" color="primary" text @click="UpdateExam(), updateexam_dialog = false">Igen</v-btn>
                          <v-btn color="primary" text @click="updateexam_dialog = false">Nem</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-snackbar v-model="updateexam_snackbar">
                      {{response}}
                      <v-btn color="pink" text @click="updateexam_snackbar = false">
                        Bezár
                      </v-btn>
                    </v-snackbar>

                  <v-col cols="6" md="3">
                    <v-btn v-if="exam_gui_id !== 'Új vizsga' && exam_id" :disabled="preloader" rounded color="primary" @click="ConfirmDeleteExam()">
                      Törlés
                      <v-icon right dark>delete</v-icon>
                    </v-btn>
                  </v-col>

                    <v-dialog v-model="deleteexam_dialog" persistent max-width="290">
                      <v-card>
                        <v-card-text>Biztosan törölni szeretné a vizsgát?</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="DeleteExam(), deleteexam_dialog = false">Igen</v-btn>
                          <v-btn color="primary" text @click="deleteexam_dialog = false">Nem</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-snackbar v-model="deleteexam_snackbar" absolute>
                      A vizsgán diákok vannak, nem törölhető!
                      <v-btn color="pink" text @click="deleteexam_snackbar = false">
                        Bezár
                      </v-btn>
                    </v-snackbar>

                    <v-col cols="6" md="3">
                      <v-btn v-if="exam_gui_id !== 'Új vizsga' && exam_id" :disabled="preloader || status == 'Finalized'" rounded color="primary" @click="archiveexam_dialog = true">
                        Archiválás
                        <v-icon right dark>archive</v-icon>
                      </v-btn>
                    </v-col>

                      <v-dialog v-model="archiveexam_dialog" persistent max-width="290">
                        <v-card>
                          <v-card-text>
                            <p v-if="status != 'Finalized'" class="red--text pt-3"><b>A vizsgajelentő még nem lett leadva!</b></p>
                            Biztosan archiválni szeretné a vizsgát?
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="ArchiveExam(), archiveexam_dialog = false">Igen</v-btn>
                            <v-btn color="primary" text @click="archiveexam_dialog = false">Nem</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                </v-row>
                <br>
                <v-row>
                  <v-col cols="6" md="3">
                    <v-btn :loading="examUpload_loading" @click="examUpload_dialog = true" v-if="exam_gui_id !== 'Új vizsga'" rounded color="primary" :disabled="!valid || !exam_students || exam_students == '' || status == 'Finalized' || examUpload_loading">
                      NKH leadás
                      <v-icon right dark>backup</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-btn @click="examDownload" v-if="exam_gui_id !== 'Új vizsga'" :disabled="!nkh_head_id || status != 'Finalized' || download_loading" :loading="download_loading" rounded color="primary">
                      Vizsgajelentő
                      <v-icon right dark>print</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" md="3">
                    <v-btn @click="vjelPrint" v-if="exam_gui_id !== 'Új vizsga'" rounded color="primary">
                      Offline vizsgajelentő
                      <v-icon right dark>print</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" md="6">
                    <v-btn v-if="exam_gui_id !== 'Új vizsga'" rounded color="primary" @click="sms_dialog = true">
                      Üzenet küldés
                      <v-icon right dark>message</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="6" md="6">
                    <v-btn v-if="status == 'Uploaded' && nkh_head_id" rounded color="primary" @click="studentsUpload">
                      Tanulók feltöltése (hibakezelés)
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                  <span v-if="sms">(A vizsga résztvevői már kaptak értesítést: {{sms}})</span>
                  </v-col>
                </v-row>
                </v-form>
              </v-container>
            </div>

            <v-dialog v-model="examUpload_dialog" persistent max-width="290">
              <v-card>
                <v-card-text class="pt-4">Biztosan le szeretné adni a vizsgát?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="examUpload(), examUpload_dialog = false">Igen</v-btn>
                  <v-btn color="primary" text @click="examUpload_dialog = false">Nem</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <div v-show="tab == 1" name="vizsgajelento_students_main">
              <v-container>
                <v-layout wrap>
                  <v-flex lg4>
                    <v-text-field v-if="status != 'Finalized'" v-model="nev" clearable @keyup.enter="SearchExamStudents" append-icon="search" label="Tanuló keresése" outlined color="#FF9800"></v-text-field>
                  </v-flex>
                  </v-layout>
                  <v-layout wrap>
                  <v-flex lg3 v-if="exam_students_search">
                    <v-btn @click="ShowExamStudents" rounded color="primary">
                      Vizsgázók listája
                      <v-icon right dark>undo</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-container>
                    <v-card v-if="exam_students && !exam_students_search" flat outlined>
                      <v-card-title>
                        Vizsgázó tanulók listája
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-data-table
                        :headers="exam_students_headers"
                        :items="exam_students"
                        :items-per-page="20"
                        hide-default-footer
                        :mobile-breakpoint='NaN'>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="(item, index) in items" :style="item.status == 441 ? {'background': '#FFF3E0'} : ''">
                              <td style='min-width: 100px'>{{ index + 1 }}</td>
                              <td style='min-width: 150px'><a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.full_name }}</a></td>
                              <td style='min-width: 110px'>{{ item.date }}</td>
                              <td>{{ item.student_id }}</td>
                              <td style='min-width: 110px'>{{ item.soap_course_type_code }}</td>
                              <td style='min-width: 80px'>{{ item.nkh_exam_category_code }}</td>
                              <td style='min-width: 100px'>{{ item.exam_time }}</td>
                              <td>
                                    <v-btn rounded outlined color="red" @click="deletestudent_dialog = true, student_delete_id = item.exam_data_id, student_delete_name = item.full_name">
                                      Töröl
                                      <v-icon right dark>delete</v-icon>
                                    </v-btn>
                              </td>
                              <td>
                                    <v-btn v-if="item.status == 441" rounded color="primary" @click="finalizePreregStudents(item.exam_data_id)">
                                      Véglegesít
                                    </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-card>
                    <v-card v-if="exam_students_search" flat outlined>
                      <v-card-title>
                        Keresett tanulók listája
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-data-table
                      :headers="search_exam_students_headers"
                      :items="exam_students_search"
                      :mobile-breakpoint='NaN'
                      >
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="(item, index) in items">
                              <td>{{ index + 1 }}</td>
                              <td><a @click="goToStudent(item.contract_id, item.customer_id)">{{ item.name }}</a></td>
                              <td>{{ item.birthdate }}</td>
                              <td>{{ item.soap_course_type_code }}</td>
                              <td>{{ item.course_start_date }}</td>
                              <td>{{ item.course_student_id }}</td>
                              <td>
                                <v-select
                                  v-model="item.exam_type"
                                  :items="exam_vizsgatargy"
                                  item-text="code"
                                  item-value="code"
                                  multiple
                                  dense
                                  :disabled="status == 'Finalized'"
                                ></v-select>
                              </td>
                              <td>

                                <v-menu
                                ref="stext_menu"
                                v-model="item.stud_exam_time_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="item.student_time"
                                transition="scale-transition"
                                offset-y

                                max-width="290px"
                                min-width="290px"
                                >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="item.student_time"
                                    append-icon="access_time"
                                    readonly
                                    v-on="on"
                                    :disabled="status == 'Finalized'"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="item.stud_exam_time_menu"
                                  v-model="item.student_time"

                                  format="24hr"
                                >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="item.stud_exam_time_menu = false">Mégsem</v-btn>
                                <v-btn text color="primary" @click="$refs.stext_menu[index].save(item.student_time)">OK</v-btn>
                                </v-time-picker>
                                </v-menu>
                                  <!--  <v-text-field v-model="item.student_time" @click="" label="Időpont" append-icon="access_time" :ref="index"></v-text-field> -->
                              </td>
                              <td>
                                <v-checkbox
                                  v-model="item.deadline_extension"
                                ></v-checkbox>
                              </td>
                              <td>
                                <v-select
                                  v-model="item.selected_payment"
                                  :items="item.payments"
                                  item-value="payment_id"
                                  multiple
                                  dense
                                  :disabled="status == 'Finalized'"
                                >
                                <template v-slot:selection="data">
                                  <!-- HTML that describe how select should render selected items -->
                                  {{ data.item.amount }}
                                </template>
                                <template v-slot:item="data">
                                  <!-- HTML that describe how select should render items when the select is open -->
                                  {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
                                </template>
                              </v-select>
                              </td>
                              <td>
                                <v-checkbox
                                  v-model="item.free_exam"
                                ></v-checkbox>
                              </td>
                              <td>
                                <v-btn :disabled="preloader || (!item.selected_payment && !item.free_exam)" v-if="exam_students_count<place_limit && status != 'Finalized'" rounded color="primary" @click="SaveExamStudents(item.contract_id, item.course_student_id, item.soap_course_type_code, item.student_time, item.exam_type, item.customer_id, item.course_type_key, item.deadline_extension, item.free_exam, item.selected_payment)">
                                  Hozzáad
                                  <v-icon right dark>add_circle_outline</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-card>
                    <v-snackbar v-model="addstudent_snackbar" bottom multi-line>
                      {{addstudent_result}}
                      <v-btn color="pink" text @click="addstudent_snackbar = false">
                        Bezár
                      </v-btn>
                    </v-snackbar>
                    <v-snackbar v-model="addstudent_error" bottom multi-line color="error">
                      {{addstudent_result}}
                      <v-btn text @click="addstudent_error = false">
                        Bezár
                      </v-btn>
                    </v-snackbar>
                  </v-container>
                </v-layout>
              </v-container>
              <v-dialog v-model="deletestudent_dialog" persistent max-width="350">
                <v-card>
                  <v-card-text class="pt-4">
                    <b>Biztosan törölni szeretné a tanulót?</b> <br> ({{student_delete_name}})
                    <p v-if="status == 'Finalized'" class="red--text"><br><b>A vizsga már fel lett töltve az NKH rendszerébe!</b> (A módosítás nem kerül feltöltésre, kizárólag a Diák Nyilvántartóban módosulnak az adatok!)</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" text @click="DeleteExamStudents(), deletestudent_dialog = false">Igen</v-btn>
                    <v-btn color="primary" text @click="deletestudent_dialog = false">Nem</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-snackbar v-model="deletestudent_snackbar" bottom>
                {{deletestudent_result}}
                <v-btn color="pink" text @click="deletestudent_snackbar = false">
                  Bezár
                </v-btn>
              </v-snackbar>
            </div>
      </v-card>

      <template>
        <v-layout justify-center>
          <v-dialog v-model="sms_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <v-toolbar dark color="primary" fixed>
                <v-toolbar-title>Üzenet küldése</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="sms_dialog = false, send_sms = null, exam_message_select = []">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <div v-if="exam_id">
                <br>
                  <p><b>Időpont:</b> {{exam_date}} ({{exam_time}})</p>
                  <p><b>Helyszín:</b> {{selected_vizsgahely_nev}}</p>
                </div>
                <v-row>
                <v-col cols="12" md="6">
                  <v-textarea
                    v-model="message_text"
                    outlined
                    name="input-7-4"
                    label="Kiegészítő szöveg"
                    auto-grow
                  ></v-textarea>
                </v-col>
                </v-row>
                <v-container>
                <v-data-table
                v-model="exam_message_select"
                v-if="exam_students"
                :headers="message_students_headers"
                :items="exam_students"
                :items-per-page="40"
                :mobile-breakpoint='NaN'
                item-key="customer_id"
                hide-default-footer
                show-select
                >
                </v-data-table>
                <v-col cols="6" md="2">
                <v-btn
                  :disabled="exam_message_select == '' || message_loader"
                  :loading="message_loader"
                  color="primary"
                  class="mr-2"
                  rounded
                  @click="smsSendFires"
                >
                Küld
                </v-btn>
                </v-col>
                Küldentő üzenetek száma: <b>{{messageCount}}</b>
                </v-container>
                <div v-html="send_sms"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>

      <v-snackbar v-model="sms_response_dialog" bottom multi-line>
        {{sms_response}}
        <v-btn color="pink" text @click="sms_response_dialog = false">
          Bezár
        </v-btn>
      </v-snackbar>

      <v-snackbar v-model="upload_response_dialog" bottom multi-line>
        {{upload_result}}
        {{upload_hiba}}
        {{upload_faultstring}}
        <v-btn color="pink" text @click="upload_response_dialog = false">
          Bezár
        </v-btn>
      </v-snackbar>

      <v-dialog v-model="exam_dialog" persistent max-width="450">
        <v-card>
          <v-container>
          <b>Biztosan előregisztrálja a tanulót?</b>
          <br><br>
          <v-select
            v-model="sel_vd"
            :items="vd_payments"
            label="Vizsgadíj hozzárendelése"
            item-value="payment_id"
            outlined
            rounded
            dense
          >
            <template v-slot:selection="data">
              <!-- HTML that describe how select should render selected items -->
              {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
            </template>
            <template v-slot:item="data">
              <!-- HTML that describe how select should render items when the select is open -->
              {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
            </template>
          </v-select>
          <v-checkbox
            v-if="admin"
            v-model="free_exam"
            label="Díjmentesség"
          ></v-checkbox>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="exam_dialog = false, examPrereg()" :disabled="!sel_vd && !free_exam">Igen</v-btn>
            <v-btn color="red" outlined @click="exam_dialog = false">Nem</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth';
import axios from 'axios'
import store from '../store'
import router from '../router'
import { mapFields } from 'vuex-map-fields'

  export default {
    data () {
      return {
        exam_students_headers: [
          { text: 'Sorszám'},
          { text: 'Név', value: 'full_name', width: 200},
          { text: 'Született', value: 'date' },
          { text: 'Azonosító', value: 'student_id' },
          { text: 'Kategória', value: 'soap_course_type_code' },
          { text: 'Tárgy', value: 'nkh_exam_category_code' },
          { text: 'Időpont', value: 'exam_time' },
          { text: ''},
        ],
        search_exam_students_headers: [
          { text: ''},
          { text: 'Név', value: 'name', width: 200},
          { text: 'Született', value: 'birthdate' },
          { text: 'Kategória', value: 'soap_course_type_code', width: 120},
          { text: 'Tanfolyam kezdete', value: 'course_start_date', width: 160},
          { text: 'Tanuló azonosító', value: 'course_student_id', width: 200},
          { text: 'Vizsgatárgy', width: 120},
          { text: 'Vizsga ideje', width: 120},
          { text: 'Hosszabbítás', width: 150},
          { text: 'Vizsgadíj', width: 120},
          { text: ''},
        ],
        message_students_headers: [
          { text: 'Sorszám'},
          { text: 'Név', value: 'full_name'},
          { text: 'Született', value: 'date' },
          { text: 'Kategória', value: 'soap_course_type_code' },
          { text: 'E-mail', value: 'email1' },
          { text: 'Telefon', value: 'phone1' },
        ],
        updateexam_dialog: false,
        tab: 0,
        updateexam_snackbar: false,
        deleteexam_dialog: false,
        deleteexam_snackbar: false,
        deletestudent_dialog: false,
        deletestudent_snackbar: false,
        deletestudent_result: '',
        addstudent_snackbar: false,
        addstudent_error: false,
        addstudent_result: '',
        validate: false,
        valid: true,
        exam_students: [],
        exam_students_search: '',
        tab1: '',
        tab2: '',
        sms: '',
        send_sms: '',
        sms_dialog: false,
        sms_response_dialog: false,
        sms_response: '',
        sms_loading: false,
        insert_id: '',
        nev: '',
        last_student_id: '',
        student_time: [],
        student_time_id: '',
        stud_exam_time_menu: false,
        student_delete_id: '',
        student_delete_name: '',
        exam_date_menu: false,
        menu2: false,
        exam_time_menu: false,
        driving_schools: [],
        exam_location_option: [
          { text: 'Petzvál', value: 1010},
          { text: 'Vas Gereben', value: 4010},
          { text: 'Komócsy', value: 3483134},
        ],
        exam_megyekir: [],
        selected_megyekir: '',
        exam_vizsgahely: [],
        selected_vizsgahely: '',
        selected_vizsgahely_nev: '',
        exam_types: [
          { text: 'Elmélet', value: 'ElmeletiVizsgaTipus', code: 'E'},
          { text: 'Gyakorlat', value: 'GyakorlatiVizsgaTipus', code: 'G'},
        ],
        selected_exam_type: '',
        exam_vizsgatipus: [],
        exam_vizsgatargy: [],
        selected_vizsgatipus: '',
        vizsgaform_loader: false,
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        payment_type: [
          { text: 'Pénztár', value: 'PENZTAR'},
          { text: 'Átutalás', value: 'ATUTALAS'},
        ],
        selected_payment_type: '',
        place_limit: 18,
        last_exam: false,
        is_published: false,
        is_preregistrabled: false,
        response: '',
        upload_response_dialog: false,
        upload_hiba: '',
        upload_result: '',
        upload_faultstring: '',
        nkh_head_id: '',
        exam_students_count: '',
        examUpload_loading: false,
        status: '',
        examUpload_dialog: false,
        exam_message_select: [],
        message_loader: false,
        message_text: '',
        archiveexam_dialog: false,
        download_loading: false,
        sel_vd: '',
        vd_payments: [],
        free_exam: false,
        exam_dialog: false,
      }
    },
    methods: {
      ExamTimeTeszt: function (index) {
        console.log(this.$refs[index][0].value);
      },
      GetMegyeKir: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.vizsgaform_loader = true
        this.$http.post('/vizsgak/get_megyekir', {
          token: this.token,
          exam_type: this.selected_exam_type['value']
        }).then((response) => {
          store.state.showing.preloader = false
          this.vizsgaform_loader = false
          this.exam_megyekir = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      GetVizsgahely: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.vizsgaform_loader = true
        this.$http.post('/vizsgak/get_vizsgahely', {
          token: this.token,
          megyekir: this.selected_megyekir,
          exam_type: this.selected_exam_type['value']
        }).then((response) => {
          store.state.showing.preloader = false
          this.vizsgaform_loader = false
          this.exam_vizsgahely = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      GetVizsgaTipus: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.vizsgaform_loader = true
        this.$http.post('/vizsgak/get_vizsgatipus', {
          token: this.token,
          megyekir: this.selected_megyekir,
          exam_type: this.selected_exam_type['value'],
          vizsgahely: this.selected_vizsgahely['VizsgaHelyszinKod']
        }).then((response) => {
          store.state.showing.preloader = false
          this.vizsgaform_loader = false
          this.exam_vizsgatipus = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      GetVizsgaTargy: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.vizsgaform_loader = true
        this.$http.post('/vizsgak/get_vizsgatargy', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.exam_vizsgatargy = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getDrivingSchool: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/driving_schools', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.driving_schools = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchExamsDetails: async function() {
        await this.gettoken()
        this.selected_exam_type = null
        this.preloader = true
        this.$http.post('/vizsgak/vizsga-details', {
          exam_id: this.exam_id,
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.exam_gui_id = response.data[0]['nkh_gui_id']
          this.status = response.data[0]['status']
          this.nkh_head_id = response.data[0]['nkh_head_id']
          this.exam_date = response.data[0]['exam_date']
          this.exam_time = response.data[0]['exam_time']
          this.school_select = response.data[0]['driving_school_id']
          this.exam_location = response.data[0]['location']
            if (response.data[0]['exam_type'] == 'E') {
            this.selected_exam_type = { text: 'Elmélet', value: 'ElmeletiVizsgaTipus', code: 'E'}
          } else if (response.data[0]['exam_type'] == 'G') {
            this.selected_exam_type = { text: 'Gyakorlat', value: 'GyakorlatiVizsgaTipus', code: 'G'}
          }
          this.selected_megyekir = response.data[0]['sub_office']
          this.selected_vizsgahely = { VizsgaHelyszinKod: response.data[0]['location'].toString(), Nev: response.data[0]['location_name'] }
          this.selected_vizsgahely_nev = response.data[0]['location_name']
          //this.selected_vizsgahely = response.data[0]['location'].toString()
          this.selected_vizsgatipus = response.data[0]['sub_type']
          this.selected_payment_type = response.data[0]['payment_type']
          this.place_limit = response.data[0]['place_limit']
          this.last_exam = response.data[0]['last_exam']
          this.is_published = response.data[0]['is_published']
          this.is_preregistrabled = response.data[0]['is_preregistrabled']
        }, (error) => {
          this.error_text = error.data
        })
      },
      GetExamStudents: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/vizsga-students', {
          exam_id: store.state.exam_details.exam_id,
          new_exam_id: store.state.exam_details.new_exam_id,
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          this.det_resp = response
          this.exam_students = response.data
          this.exam_students_count = this.exam_students.length

        }, (error) => {
          this.error_text = error.data
        })
      },
      updateExamStudents: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/update-vizsga-students', {
          exam_id: store.state.exam_details.exam_id,
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          //this.sms_response_dialog = true
          this.sms_response = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      finalizePreregStudents: async function (exam_data_id) {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/finalize_prereg_students', {
          exam_data_id: exam_data_id,
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          this.sms_response_dialog = true
          this.sms_response = response.data
          this.GetExamStudents()
        }, (error) => {
          this.error_text = error.data
        })
      },
      SearchExamStudents: async function () {
        this.exam_students_search = ''
        this.student_time = this.exam_time
        this.nev = this.nev.trim()
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/vizsga_search_students_20210721', {
          exam_id: store.state.exam_details.exam_id,
          new_exam_id: store.state.exam_details.new_exam_id,
          token: this.token,
          nev: this.nev
        }).then((response) => {
          store.state.showing.preloader = false
          this.exam_students_search = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      ShowExamStudents: function () {
        this.exam_students_search = null
        this.GetExamStudents()
      },
      SaveExamStudents: async function (contract_id, course_student_id, soap_course_type_code, student_time, exam_type, customer_id, course_type_key, deadline_extension, free_exam, selected_payment) {
        await this.gettoken()
        this.preloader = true
        this.$http.post('/vizsgak/vizsga_add_students_20220308', {
          exam_id: this.exam_id,
          exam_date: this.exam_date,
          token: this.token,
          contract_id: contract_id,
          customer_id: customer_id,
          student_id: course_student_id,
          exam_time: student_time,
          exam_type: exam_type,
          category: soap_course_type_code,
          category_code: course_type_key,
          deadline_extension: deadline_extension,
          free_exam: free_exam,
          vd_payment: selected_payment
        }).then((response) => {
          this.preloader = false
          if (response.data['success'] == true) {
            this.addstudent_snackbar = true
          } else {
            this.addstudent_error = true
          }
          this.addstudent_result = response.data['message']
          this.GetExamStudents()
          //M.toast({html: this.last_student_id, classes: 'rounded'})
          console.log(this.last_student_id);
        }, (error) => {
          this.error_text = error.data
        })
      },
      vdPayments: async function() {
        this.sel_vd = null
        this.free_exam = false
        await this.gettoken()
        this.$http.post('/diakok/vd_payments', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.vd_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      DeleteExamStudents: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/vizsga_delete_students_20210721', {
          token: this.token,
          id: this.student_delete_id,
        }).then((response) => {
          this.deletestudent_snackbar = true
          this.deletestudent_result = response.data
          store.state.showing.preloader = false
          this.GetExamStudents()
          this.$eventBus.$emit('prereg');
        }, (error) => {
          this.error_text = error.data
        })
      },
      goToStudent(contract_id, customer_id) {
        this.Diakok_show = false
        this.DiakokDetails_show = true
        this.contract_id = null
        this.customer_id = null
        this.contract_date = null
        this.contract_id = contract_id
        this.customer_id = customer_id
        router.push({ path: 'diakok' })
      },
      SaveExam: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/save_exam', {
          token: this.token,
          exam_gui_id: this.exam_gui_id,
          exam_date: this.exam_date,
          exam_time: this.exam_time,
          school_select: this.school_select['nkh_user_name'],
          school_id: this.school_select['driving_school_id'],
          exam_location: this.selected_vizsgahely['VizsgaHelyszinKod'],
          exam_location_name: this.selected_vizsgahely['Nev'],
          megyekir: this.selected_megyekir,
          exam_type: this.selected_exam_type['code'],
          sub_type: this.selected_vizsgatipus,
          payment_type: this.selected_payment_type,
          place_limit: this.place_limit,
          last_exam: this.last_exam,
          is_published: this.is_published,
          is_preregistrabled: this.is_preregistrabled
        }).then((response) => {
          console.log(response.data);
          this.response = response.data['response']
          this.exam_id = response.data['id']
          this.updateexam_snackbar = true
          store.state.showing.preloader = false
          this.$eventBus.$emit('prereg');
        }, (error) => {
          this.error_text = error.data
        })
      },
      UpdateExam: async function () {
        await this.gettoken()
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/update_exam', {
          token: this.token,
          exam_id: this.exam_id,
          exam_date: this.exam_date,
          exam_time: this.exam_time,
          exam_location: this.selected_vizsgahely['VizsgaHelyszinKod'],
          exam_location_name: this.selected_vizsgahely['Nev'],
          megyekir: this.selected_megyekir,
          exam_type: this.selected_exam_type['code'],
          sub_type: this.selected_vizsgatipus,
          payment_type: this.selected_payment_type,
          place_limit: this.place_limit,
          last_exam: this.last_exam,
          is_published: this.is_published,
          is_preregistrabled: this.is_preregistrabled
        }).then((response) => {
          this.response = response.data
          this.updateexam_snackbar = true
          store.state.showing.preloader = false
          this.fetchExamsDetails()
          this.updateExamStudents()
          this.GetExamStudents()
          this.$eventBus.$emit('prereg');
        }, (error) => {
          this.error_text = error.data
        })
      },
      ConfirmDeleteExam: function () {
        if (this.exam_students != '') {
          this.deleteexam_snackbar = true
        } else {
          this.deleteexam_dialog = true
        }
      },
      DeleteExam: async function () {
        await this.gettoken()
        this.$http.post('/vizsgak/delete_exam', {
          token: this.token,
          exam_id: this.exam_id
        }).then((response) => {
          this.$eventBus.$emit('deleteresult', response.data);
          store.state.showing.VizsgaDetails_show = false,
          store.state.showing.Vizsgak_show = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      ArchiveExam: async function () {
        await this.gettoken()
        this.$http.post('/vizsgak/archive_exam', {
          token: this.token,
          exam_id: this.exam_id
        }).then((response) => {
          this.$eventBus.$emit('deleteresult', response.data);
          store.state.showing.VizsgaDetails_show = false,
          store.state.showing.Vizsgak_show = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      examUpload: async function () {
        this.examUpload_loading=true
        await this.gettoken()
        this.$http.post('/vizsgak/vizsga_upload', {
          token: this.token,
          exam_id: this.exam_id,
          nkh_head_id: this.nkh_head_id,
          school_id: this.school_select,
          exam_gui_id: this.exam_gui_id
        }).then((response) => {
          this.examUpload_loading=false
          this.upload_hiba = response.data['error'];
          this.upload_result = response.data['result'];
          this.upload_faultstring = response.data['faultstring'];
          this.upload_response_dialog = true
          this.fetchExamsDetails()

        }, (error) => {
          this.error_text = error.data
        })
      },
      examDownload: async function() {
        this.preloader = true
        this.download_loading = true
        await this.gettoken()
        this.$http.post('/vizsgak/vizsga_download', {
          token: this.token,
          nkh_head_id: this.nkh_head_id,
          driving_school_id: this.school_select
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          this.download_loading = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.preloader = false
          this.download_loading = false
          this.error_text = error.data
        })
      },
      vjelPrint: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/vizsgak/vizsgajelento/vizsgajelento', {
          token: this.token,
          exam_id: this.exam_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      NewExamDetails: async function () {
        await this.gettoken()
        store.state.exam_details.exam_gui_id = ''
        store.state.exam_details.exam_id = ''
        store.state.exam_details.new_exam_id = this.insert_id
        store.state.showing.preloader = true
        this.$http.post('/vizsgak/vizsga-details', {
          exam_id: this.exam_id,
          new_exam_id: this.insert_id,
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          store.state.exam_details.exam_gui_id = response.data[0]['nkh_gui_id']
          store.state.exam_details.exam_date = response.data[0]['exam_date']
          store.state.exam_details.exam_time = response.data[0]['exam_time']
          store.state.exam_details.school_select = response.data[0]['exam_code']
          store.state.exam_details.exam_location = response.data[0]['location']
        }, (error) => {
          this.error_text = error.data
        })
      },
      newExam() {
        this.exam_gui_id = ''
        this.VizsgaDetails_show = true
        this.Vizsgak_show = false
        this.exam_gui_id = 'Új vizsga'
        this.exam_date = ''
        this.exam_time = ''
        this.school_select = ''
        this.exam_location = ''
        this.exam_id = null
        this.selected_megyekir = null
        this.selected_vizsgahely = null
        this.selected_exam_type = { text: 'Elmélet', value: 'ElmeletiVizsgaTipus', code: 'E'}
        this.selected_vizsgatipus = null
        this.exam_megyekir = []
        this.exam_vizsgahely = []
        this.exam_vizsgatipus = []
        this.selected_payment_type = null
        this.place_limit = 18
        this.last_exam = false
        this.is_published = false
        this.is_preregistrabled = false
      },
      newExamCall: async function() {
        await this.newExam()
        this.resetValidation()
      },
      smsCheck: async function() {
        this.sms = null
        await this.gettoken()
        this.$http.post('/vizsgak/sms_check', {
          exam_id: store.state.exam_details.exam_id,
          token: this.token
        }).then((response) => {
          this.sms = response.data[0]['sms']
        }, (error) => {
          this.error_text = error.data
        })
      },
      smsSend: async function () {
        await this.gettoken()
        this.$http.post('/vizsgak/kresz-sms-overview', {
          exam_id: store.state.exam_details.exam_id,
          token: this.token,
          responseType: 'text'
        }).then((response) => {
          this.send_sms = response.data
          this.sms_dialog = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      smsSendFires: async function () {
        this.message_loader = true
        await this.gettoken()
        this.$http.post('/vizsgak/kresz_message', {
          exam_id: store.state.exam_details.exam_id,
          exam_place: this.selected_vizsgahely,
          token: this.token,
          date: this.exam_date,
          time: this.exam_time,
          students: this.exam_message_select,
          message_text: this.message_text
        }).then((response) => {
          this.message_loader = false
          this.send_sms = response.data
          this.exam_message_select = []
          this.message_text = null
          this.smsCheck()
        }, (error) => {
          this.error_text = error.data
        })
      },
      smsSendexamChange: async function () {
        this.sms_loading = true
        await this.gettoken()
        this.$http.post('/vizsgak/kresz-valtozas-sms', {
          exam_id: store.state.exam_details.exam_id,
          token: this.token,
          responseType: 'text'
        }).then((response) => {
          this.sms_loading = false
          this.send_sms = response.data
          this.smsCheck()
        }, (error) => {
          this.error_text = error.data
        })
      },
      studentsUpload: async function () {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/vizsgak/vizsga_upload_students', {
          token: this.token,
          exam_id: this.exam_id,
          school_id: this.school_select
        }).then((response) => {
          store.state.showing.preloader = false
          console.log(response.data);
          /*
          this.upload_hiba = response.data['error'];
          this.upload_result = response.data['result'];
          this.upload_faultstring = response.data['faultstring'];
          this.upload_response_dialog = true
          */
          this.fetchExamsDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      resetValidation () {
      this.$refs.exam_form.resetValidation()
      },
    },

    mounted() {
      this.GetMegyeKir();
      this.getDrivingSchool();
      this.GetVizsgaTargy()
    },
    created() {
      this.$eventBus.$on('newExam', () => {
            this.newExamCall();
      })
    },
  watch: {
    exam_id: function (value) {
      if (value) {
        this.fetchExamsDetails()
      }
    },
    VizsgaDetails_show: function (value) {
      this.exam_students = null
      this.exam_students_search = null
      if (value == true && store.state.exam_details.exam_gui_id != 'Új vizsga') {
        this.GetExamStudents()
        this.smsCheck()
      }
    },
    insert_id: function () {
      this.NewExamDetails()
    },
    exam_students_search: function () {

    },
    selected_megyekir() {
      this.GetVizsgahely()
    },
    selected_exam_type() {
      this.GetMegyeKir()
      this.GetVizsgahely()
      this.GetVizsgaTipus()
    },
    selected_vizsgahely() {
      this.GetVizsgaTipus()
    },
    tab: function (value) {
      if (value == 1) {
        this.GetExamStudents()
      }
    }
  },
  computed: {
  ...mapFields([
  'showing.VizsgaDetails_show',
  'showing.Vizsgak_show',
  'showing.preloader',
  'exam_details.exam_gui_id',
  'exam_details.exam_date',
  'exam_details.exam_time',
  'exam_details.school_select',
  'exam_details.exam_location',
  'exam_details.exam_id',
  'exam_details.new_exam_id',
  'showing.Diakok_show',
  'showing.DiakokDetails_show',
  'diakok_details.contract_id',
  'diakok_details.customer_id',
  'auth.admin',
  ]),
  messageCount: function () {
      return this.exam_message_select.length;
  }
  },
}
</script>

<style lang="css">

</style>
